import "aos/dist/aos.css";
import PricingCard from "../../comp/pricing-card/PricingCard";

const Pricing = () => {
  return (
    <>
      <video
        src="/Digital_Grapes.mp4"
        autoPlay
        loop
        muted
        className="video w-full h-screen object-cover fixed top-0 opacity-50"
      ></video>
      <div className="my-1">
        <div>
          <h1
            className="lg:text-5xl md:text-3xl text-2xl font-bold text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Choose Your{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7] animate-bounce">
              Plan
            </span>
          </h1>
          <h2 className="text-center text-gray-500 pt-4">
            Please fill out the form below with your details and requirements,
            and we'll get back to you with a customized quote.
          </h2>
        </div>
      </div>

      <div className="w-10/12 h-[85vh] mx-auto p-4 flex gap-24">
        <PricingCard />
      </div>
    </>
  );
};

export default Pricing;
